const getValidTime = (value) => {
    if (!value) return Number.POSITIVE_INFINITY;

    const date = new Date(value);
    const time = date.getTime();

    return Number.isNaN(time) ? Number.POSITIVE_INFINITY : time;
};

const normalizeText = (value) => String(value || "").trim().toLowerCase();

const getFirstValue = (row, keys) => {
    for (const key of keys) {
        const value = row?.[key];

        if (value !== undefined && value !== null && value !== "") {
            return value;
        }
    }

    return null;
};

export const sortDueDateRows = (
    rows,
    {
        dueDateKeys = ["subscriptionEndDate", "dueDate"],
        yearKeys = ["serviceYear", "year", "clientServiceSubscriptionYear"],
        serviceNameKeys = [
            "serviceName",
            "clientServiceSubscriptionServiceName",
            "service",
        ],
    } = {},
) => {
    if (!Array.isArray(rows)) return [];

    return [...rows].sort((a, b) => {
        const dueA = getValidTime(getFirstValue(a, dueDateKeys));
        const dueB = getValidTime(getFirstValue(b, dueDateKeys));

        if (dueA !== dueB) return dueA - dueB;

        const yearA = Number(getFirstValue(a, yearKeys) || 0);
        const yearB = Number(getFirstValue(b, yearKeys) || 0);

        if (yearA !== yearB) return yearB - yearA;

        const serviceA = normalizeText(getFirstValue(a, serviceNameKeys));
        const serviceB = normalizeText(getFirstValue(b, serviceNameKeys));

        return serviceA.localeCompare(serviceB);
    });
};
